"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import {
  AgxNotificationBox,
  IconTaskTypes,
} from '@urbanx/agx.ui-components2'
import { useSelectedCampaign } from 'hooks'
import { JSX, useEffect, useState } from 'react'
import AgreementComplianceModal from 'pages/allTasks/TaskModal/AgreementComplianceModal'
import TaskModalEntry from 'pages/allTasks/TaskModal/TaskModalEntry'

interface AgreementComplianceProps {
  tasks: AutopilotTaskDto[]
  badge: JSX.Element
}

const AgreementCompliance = ({ tasks, badge }: AgreementComplianceProps) => {
  const { campaign } = useSelectedCampaign()
  const [modalTasks, setModalTasks] = useState(tasks)
  const [isAgreementComplianceModalOpen, setIsAgreementComplianceModalOpen] =
    useState(false)

  useEffect(() => {
    if (!isAgreementComplianceModalOpen) {
      setModalTasks(tasks)
    }
  }, [isAgreementComplianceModalOpen, tasks])

  return (
    <>
      {campaign?.campaignId && (
        <AgreementComplianceModal
          tasks={modalTasks}
          isOpen={isAgreementComplianceModalOpen}
          onClose={() => setIsAgreementComplianceModalOpen(false)}
          campaignId={campaign.campaignId}
        />
      )}
      <TaskModalEntry
        title="Agreement Compliance"
        tasks={tasks}
        badge={badge}
        iconType={IconTaskTypes.AgreementCompliance}
        actionText="Complete Compliance Check"
        actionButtonId="completeComplianceCheckBtn"
        panelKey="AgreementCompliancePanel"
        onAction={(currentTasks) => {
          setModalTasks(currentTasks)
          setIsAgreementComplianceModalOpen(true)
        }}
        notification={
          campaign?.flatCommissionBelowMinimumAlert ? (
            <AgxNotificationBox
              type="warning"
              heading=""
              body="Commission rate is low. Alert Admin Manager and confirm rate is correct before proceeding."
            />
          ) : undefined
        }
      />
    </>
  )
}
export default AgreementCompliance
